import React from 'react';
import _ from 'lodash';
import parts from '../../../utilities/parts';

import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';
import { messageUtility } from '../../../utilities/messageUtility';

/**
 * 作業員ヘッダー
 * @props {object}LinkButtonObject:戻る etc... リンクのオブジェクト
 * LinkButtonObject プロパティに必要なプロパティ
 *   {string}label: テキスト
 *   {string}className: クラス名
 *   {function}onClick: 処理
 *
 * @props {object}buttonObject:ボタンオブジェクト
 * buttonObject プロパティに必要なプロパティ
 *   {string}label: テキスト
 *   {string}className: クラス名
 *   {function}onClick: 処理
 */
export class WorkerHeader extends React.Component {
  constructor(props) {
    super(props);

    // 戻る etc... リンクのオブジェクトの設定
    if (
      isNullOrUndefinedOrEmptyStr(this.props.LinkButtonObject) === false &&
      parts.isEmptyObject(this.props.LinkButtonObject) === false
    ) {
      // this.state.LinkButtonObject = this.props.LinkButtonObject;
      _.map(this.props.LinkButtonObject, obj => {
        if (
          isNullOrUndefinedOrEmptyStr(obj.onClick) === false &&
          _.isFunction(obj.onClick) === false
        ) {
          console.warn('onClick is not function');
          obj.onClick = null;
        }
      });
    }

    // 各ボタンの設定
    if (
      isNullOrUndefinedOrEmptyStr(this.props.buttonObject) === false &&
      parts.isEmptyObject(this.props.buttonObject) === false
    ) {
      _.map(this.props.buttonObject, obj => {
        if (
          isNullOrUndefinedOrEmptyStr(obj.onClick) === false &&
          _.isFunction(obj.onClick) === false
        ) {
          console.warn('onClick is not function');
          obj.onClick = null;
        }
      });
    }
  }

  componentDidUpdate() {
    if (!_.isInteger(this.props.errorMessagesCount)) {
      throw new Error(
        'WorkerHeader.jsx props.errorMessagesCount is not integer'
      );
    }
  }

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <div className='contruction-detail-view__header'>
          {_.map(this.props.LinkButtonObject, (item, index) => {
            return (
              <span key={index}>
                <button className={item.className} onClick={item.onClick}>
                  <i className='i-back--blue i-2x vertical-middle' />
                  {item.label}
                </button>
              </span>
            );
          })}
        </div>
        <div className='contruction-detail-view__menu'>
          {_.map(this.props.buttonObject, (item, index) => {
            let buttonClassName = item.className;
            let isDisabled = false;
            if (index === 'register') {
              if (this.props.errorMessagesCount >= 1) {
                buttonClassName += ' btn--disabled';
                isDisabled = true;
              }
            }
            if (item.isSetDisabled && this.props.isDisabled) {
              buttonClassName += ' btn--disabled';
              isDisabled = true;
            }
            return (
              <span className='construction-detail-view__button' key={index}>
                <button
                  className={buttonClassName}
                  onClick={item.onClick}
                  data-testid={
                    item.label === '更新' ? 'worker_header_edit' : ''
                  }
                  disabled={isDisabled}
                >
                  {item.label}
                </button>
              </span>
            );
          })}
          <span className='construction-detail-view__multiple-alert-text'>
            {this.props.errorMessagesCount === 0
              ? null
              : messageUtility.getMessage('E-000-014')}
          </span>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/worker/header/WorkerHeader.jsx